import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';

import LabelCheckbox from '../../../components/LabelCheckbox';
import { COUNTRY_OPTIONS } from '../utils/constants';
import ChipMultiSelect from './ChipMultiSelect';

const CountryConsentFields = ({
  countries,
  requireConsent,
  onToggleCountry,
  onRequireConsentChange,
  countryLabel,
  consentLabel,
  showConsent,
}) => (
  <>
    <ChipMultiSelect
      label={countryLabel}
      options={COUNTRY_OPTIONS}
      selected={countries}
      onToggle={onToggleCountry}
    />

    {showConsent && (
      <Alert
        severity="warning"
        sx={{
          marginTop: 2,
          alignItems: 'center',
          '& .MuiAlert-message': { paddingY: 0, display: 'flex', alignItems: 'center' },
        }}
      >
        <LabelCheckbox
          isChecked={requireConsent}
          onChange={onRequireConsentChange}
          description={consentLabel}
        />
      </Alert>
    )}
  </>
);

CountryConsentFields.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.string).isRequired,
  requireConsent: PropTypes.bool.isRequired,
  onToggleCountry: PropTypes.func.isRequired,
  onRequireConsentChange: PropTypes.func.isRequired,
  countryLabel: PropTypes.string.isRequired,
  consentLabel: PropTypes.string.isRequired,
  showConsent: PropTypes.bool,
};

CountryConsentFields.defaultProps = {
  showConsent: true,
};

export default CountryConsentFields;
